// Mobile-only: physically move .ash-auto-cs-mobile-wrap INSIDE the
// product-card's <product-price> element so the swatches and the price
// text share one DOM row. The CSS counterpart makes <product-price> a
// flex container on mobile that pushes swatches to the right.
//
// We run once on init, again on every relevant DOM mutation, and on
// every viewport resize that crosses the 750px breakpoint. On desktop
// (≥750px) we put the wrap BACK to its original position (sibling of
// product-price) so the desktop layout — which hides the mobile copy
// — is unaffected.
(function () {
  if (window.__ashMobileSwatchInit) return;
  window.__ashMobileSwatchInit = true;

  var MQ = window.matchMedia('(max-width: 749px)');

  function placeOne(wrap) {
    var card = wrap.closest('product-card, .product-card');
    if (!card) return;
    var price = card.querySelector('product-price');
    if (!price) return;

    var mobile = MQ.matches;
    if (mobile) {
      if (wrap.parentNode !== price) {
        price.appendChild(wrap);
        wrap.setAttribute('data-injected', 'price');
      }
    } else {
      // Desktop: put it back as a sibling of product-price (next to it)
      // so it doesn't show inside the price block.
      if (wrap.getAttribute('data-injected') === 'price' && wrap.parentNode === price) {
        if (price.parentNode) price.parentNode.insertBefore(wrap, price.nextSibling);
        wrap.removeAttribute('data-injected');
      }
    }
  }

  function placeAll(root) {
    (root || document).querySelectorAll('.ash-auto-cs-mobile-wrap').forEach(placeOne);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      placeAll(document);
    });
  }

  function start() {
    placeAll(document);

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (
            n.matches &&
            n.matches('.ash-auto-cs-mobile-wrap, product-card, .product-card, product-price')
          ) {
            schedule();
            return;
          }
          if (
            n.querySelector &&
            n.querySelector('.ash-auto-cs-mobile-wrap, product-price')
          ) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (MQ.addEventListener) {
      MQ.addEventListener('change', schedule);
    } else if (MQ.addListener) {
      MQ.addListener(schedule);
    }

    document.addEventListener('shopify:section:load', function (e) {
      placeAll(e.target);
    });

    // Brief safety net for slow injections; MO + section:load cover later.
    var ticks = 0;
    var poll = setInterval(function () {
      placeAll(document);
      if (++ticks > 6) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
